// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".table-header[data-v-21c3a6e2]{background-color:beige;border-bottom:2px solid #d3d3d3}.table-row[data-v-21c3a6e2]{background-color:#f9f9f9}.with-border[data-v-21c3a6e2]{border-right:2px solid #d3d3d3}td[data-v-21c3a6e2],th[data-v-21c3a6e2]{border-bottom:2px solid #d3d3d3!important;padding:8px}.table-row:last-child td[data-v-21c3a6e2]{border-bottom:none!important}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
